<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container-fluid">
      <slot />
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import MyFooter from "@/components/MyFooter";

export default {
  components: {
    NavBar,
    MyFooter
  }
};
</script>

<style scoped>
@import "../assets/bootstrap.min.css";
</style>
